import { Component } from "@angular/core";
import { environment } from "../../../environments/environment";
import { PlanningPokerService } from "../../services/planning-poker/planning-poker.service";

@Component({
  selector: "app-voting-risk-indicator",
  templateUrl: "./voting-risk-indicator.component.html",
  styleUrls: ["./voting-risk-indicator.component.scss"],
})
export class VotingRiskIndicatorComponent {
  readonly env: any = environment;

  constructor(public planningPokerService: PlanningPokerService) {}
}



// WEBPACK FOOTER //
// /agir/src/app/components/voting-risk-indicator/voting-risk-indicator.component.ts